import { useQuery } from 'react-query'
import { occurrencesService } from '../../../services/occurrencesService'

export const hasUnreadOccurrencesKey = ['occurrences', 'has-unread'] as const

/**
 * "Existe mensagem não lida em algum processo meu?" — fonte única da bolinha
 * vermelha no item Ocorrências da sidebar padrão e do título piscante da aba
 * (`useOccurrencesTabTitle`). Mesmo papel de `useHasUnreadReportedIssues` em
 * Problemas Reportados.
 *
 * `enabled` porque a rota exige a capability `canAccessOccurrences` + feature
 * `occurrences`: sem o gate, quem não tem acesso levaria 403 em toda página.
 * Poll de 60s porque a sidebar não fica no socket de Ocorrências (que só é
 * montado dentro da própria página).
 */
export function useHasUnreadOccurrences(enabled: boolean): boolean {
  const { data } = useQuery(
    hasUnreadOccurrencesKey,
    () => occurrencesService.hasUnread(),
    {
      enabled,
      staleTime: 30 * 1000,
      refetchInterval: 60 * 1000,
      refetchOnWindowFocus: true,
      // Sem retry: um 403 (capability revogada no meio da sessão) viraria 4
      // requests a cada poll. Falha simplesmente não acende a bolinha.
      retry: false,
      onError: () => undefined,
    },
  )
  return data === true
}
